if (__IS_LEGACY__) {
  require('core-js/stable')
  require('whatwg-fetch')
}

async function init() {
  if (!('IntersectionObserver' in window)) {
    try {
      await import('intersection-observer' /* webpackChunkName: "intersection-observer" */)
    } catch (e) {
      console.error(e)
    }
  }

  if (!('customElements' in window)) {
    await import('@webcomponents/custom-elements' /* webpackChunkName: "custom-elements" */)
  }

  require('./v1/client')
}
init()
